<template>
  <ReorganizationDrawer
    @eventHandler="reorganizationDrawerHandler"
    v-if="!seeAllDrawerEnabled"
  />
  <SeeAll
    v-if="seeAllDrawerEnabled"
    @scrollEventHandler="scrollToElement"
    active-store="vehicle"
    set-param="filterForm/setParam"
  />
  <div
    id="filter-sidebar"
    v-show="!reorganizationDrawerEnabled && !seeAllDrawerEnabled && !vehiclesFilterLoading"
  >
    <div>
      <div v-for="section in sections" v-bind:key="section.key">
        <div
          id="location"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.Location"
        >
          <Location
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="advertiser-type"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.AdvertiserType"
        >
          <CheckBoxes
            title="Tipo de anunciante"
            @update="$store.commit('filterForm/setParam', { adType: $event })"
            :options="advertiserTypes"
            id="adType"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="vehicleType"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.Category"
        >
          <VehicleType
            title="Categoria"
            :category="category"
            :vehiclesTypeSelected="vehiclesTypeSelected"
            :params="params"
            set-param="filterForm/setParam"
            clear="filterForm/clear"
          />
        </div>

        <div
          id="purchase-method"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.PurchaseMode"
        >
          <CheckBoxes
            title="Modalidade de Compra"
            @update="
              $store.commit('filterForm/setParam', { quotation: $event })
            "
            :options="PURCHASE_METHODS"
            id="quotation"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="vehicle-type"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.VehicleType"
        >
          <CheckBoxes
            title="Tipo de veículo"
            @update="
              $store.commit('filterForm/setParam', { typeVehicle: $event })
            "
            :options="VEHICLE_TYPES"
            id="typeVehicle"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="vehicle-condition"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.VehicleCondition"
        >
          <CheckBoxes
            title="Condição do veículo"
            @update="
              $store.commit('filterForm/setParam', { vehicleCondition: $event })
            "
            :options="VEHICLE_CONDITIONS"
            id="vehicleCondition"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="report"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.Report"
        >
          <CheckBoxes
            title="Laudo"
            @update="$store.commit('filterForm/updateReportStatus', $event)"
            :options="REPORT_STATUSES"
            id="reportStatus"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="optionals"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.Opcional"
        >
          <CheckBoxes
            title="Opcionais"
            @update="
              $store.commit('filterForm/setParam', { optionals: $event })
            "
            :options="OPTIONAL_TYPES"
            :see-all="{
              title: 'Ver todos os opcionais',
              placeholder: 'Digite a opção desejada',
              menu: 'Opcionais',
              submenu: 'Todos os opcionais',
              handle: () => seeAllOptionalsClickHandler(),
              scrollTo: 'optionals',
            }"
            id="optionals"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="fuel"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.Fuel"
        >
          <CheckBoxes
            title="Combustível"
            @update="$store.commit('filterForm/setParam', { fuel: $event })"
            :options="FUEL_TYPES"
            id="fuel"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="transmission"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.Transmission"
        >
          <CheckBoxes
            title="Transmissão"
            @update="
              $store.commit('filterForm/setParam', { transmission: $event })
            "
            :options="TRANSMISSION_TYPES"
            id="transmission"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="fipe"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.Fipe"
        >
          <Fipe
              ref="fipeComponentRef"
              :set-fipe-store-handle="setFipe"
              :set-fipe-value-store-handle="setFipeValue"
              active-store="vehicle"
          />
        </div>

        <div
          id="vehicle-branding"
          class="sidebar-item mt-5"
          v-if="section.key === SECTIONS_KEYS.VehicleBranding"
        >
          <VehicleBranding
            :see-all="{
              title: 'Ver todas as marcas',
              placeholder: 'Digite a marca desejada',
              menu: 'Marcas',
              submenu: 'Ver todas as marcas',
              handle: () => seeAllBrandsClickHandler(),
              scrollTo: 'vehicle-branding',
            }"
            active-store="vehicle"
            set-param="filterForm/setParam"
          />
        </div>

        <div
          id="vehicle-price"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.VehiclePrice"
        >
          <VehiclePriceRange
              :price-max="priceMax"
              :price-min="priceMin"
              :set-price-max-store-handle="setPriceMax"
              :set-price-min-store-handle="setPriceMin"
          />
        </div>

        <div
          id="vehicle-year"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.VehicleYear"
        >
          <VehicleYearRange
              :year-max="yearMax"
              :year-min="yearMin"
              :set-year-max-store-handle="setYearMax"
              :set-year-min-store-handle="setYearMin"
          />
        </div>

        <div
          id="vehicle-km"
          class="sidebar-item"
          v-if="section.key === SECTIONS_KEYS.VehicleKM"
        >
          <VehicleKMRange
              :km-max="kmMax"
              :km-min="kmMin"
              :set-km-max-store-handle="setKmMax"
              :set-km-min-store-handle="setKmMin"
          />
        </div>
      </div>

      <button class="clear-button" @click="() => limparFiltro($store)">
        <img
          :src="require('@/assets/icons/trash-icon.svg')"
          width="24"
          height="24"
        />
        <span id="filter-sidebar-limpar">Limpar</span>
      </button>

      <v-divider></v-divider>

      <StockExportButton view="vehicle" />

      <div class="spacer-fill"></div>
      
      <div id="autoavaliar-logo" class="mb-4" :style="{ paddingBottom: padding }">
        <img :src="require('@/assets/icons/logo-icon.svg')" class="img"/>
      </div>
    </div>
  </div>

  <FilterSidebarSkeleton
      v-if="vehiclesFilterLoading"
      :sections="sections"
  />

  <div class="container" v-if="isMobile()"></div>
  <div class="footer" v-if="isMobile() && filterDesktopHide && seeAllDrawerEnabled === false">
    <v-btn
      variant="plain"
      id="button"
      width="248px"
      height="49px"
      @click="closeSidebar"
      class="text-none"
    >
      <span>Filtrar</span>
      <span v-if="totalResults > 0 && loading === false"
        >({{ totalResults }})</span
      >
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import CheckBoxes from "@/components/inputs/CheckBoxes.vue";
import ReorganizationDrawer from "@/components/drawers/ReorganizationDrawer.vue";
import Location from "@/components/Location.vue";
import VehicleType from "@/components/VehicleType.vue";
import Fipe from "@/components/Fipe.vue";
import VehiclePriceRange from "./VehiclePriceRange.vue";
import VehicleYearRange from "./VehicleYearRange.vue";
import VehicleKMRange from "./VehicleKMRange.vue";
import SECTIONS_DEFAULT from "@/constants/SectionsDefault";
import SECTIONS_KEYS from "@/constants/SectionsKeys";
import SeeAll from "@/components/drawers/SeeAll.vue";
import VehicleBranding from "@/components/VehicleBrandings.vue";
import testStorage from "@/services/localStorage";
import {
  PURCHASE_METHODS,
  VEHICLE_TYPES,
  VEHICLE_CONDITIONS,
  REPORT_STATUSES,
  FUEL_TYPES,
  TRANSMISSION_TYPES,
  OPTIONAL_TYPES,
} from '@/constants/FilterOptions';
import StockExportButton from "./StockExportButton.vue";
import FilterSidebarSkeleton from "@/components/FilterSidebarSkeleton.vue";
import {getAdvertiserTypeByCompanyUrl} from "@/services/api/FiltersServiceApi";
import PlatformsMixins from "@/mixins/PlatformsMixins";

export default {
  name: "FilterSidebar",
  mixins: [PlatformsMixins],
  components: {
    FilterSidebarSkeleton,
    SeeAll,
    CheckBoxes,
    ReorganizationDrawer,
    Location,
    VehicleType,
    Fipe,
    VehiclePriceRange,
    VehicleYearRange,
    VehicleKMRange,
    VehicleBranding,
    StockExportButton,
  },
  data: function () {
    return {
      PURCHASE_METHODS,
      VEHICLE_TYPES,
      VEHICLE_CONDITIONS,
      REPORT_STATUSES,
      OPTIONAL_TYPES,
      FUEL_TYPES,
      TRANSMISSION_TYPES,
      padding: '28px'
    };
  },
  props: {
    closeSidebar: Function,
    validParam: String,
    currentResolvedPadding: String
  },
  mounted: function () {
    if(testStorage()){
    if (localStorage.getItem("sections")) {
      try {
        this.setSections(JSON.parse(localStorage.getItem("sections")));
      } catch (e) {
        localStorage.removeItem("sections");
      }
    } else {
      this.setSections(SECTIONS_DEFAULT);
    }
    this.loadFromCache();
    }else{
      this.setSections(SECTIONS_DEFAULT);
    }
    if (this.validParam && typeof this.validParam == 'string') {
      this.loadAdvertiserTypeForCompany(this.validParam);
    }
  },
  watch: {
    currentResolvedPadding(newVal) {
      this.padding = newVal
    },
  },
  computed: {
    SECTIONS_KEYS() {
      return SECTIONS_KEYS
    },
    ...mapState({
      sections: (state) => state.sections.list,
      params: (state) => state.filterForm.params,
      optionalsData: (state) => state.filterForm.optionalsData,
      reorganizationDrawerEnabled: (state) =>
        state.drawer.reorganizationDrawerEnabled,
      seeAllDrawerEnabled: (state) => state.drawer.seeAllDrawerEnabled,
      loading: (state) => state.filterForm.loading,
      totalResults: (state) => state.filterForm.totalOfResult,
      category: state => state.filterForm.params.category?.length > 0 ? state.filterForm.params.category[0] : null,
      vehiclesTypeSelected: (state) => state.filterForm.params["category"] ?? [],
      priceMin: (state) => state.filterForm.params.priceMin ?? state.filterForm.priceMin,
      priceMax: (state) => state.filterForm.params.priceMax ?? state.filterForm.priceMax,
      yearMin: (state) => state.filterForm.params.yearMin ?? state.filterForm.yearMin,
      yearMax: (state) => state.filterForm.params.yearMax ?? state.filterForm.yearMax,
      kmMin: (state) => state.filterForm.params.kmMin ?? state.filterForm.kmMin,
      kmMax: (state) => state.filterForm.params.kmMax ?? state.filterForm.kmMax,
      brands: (state) => state.filterForm.params.brands,
      models: (state) => state.filterForm.params.models,
      vehiclesFilterLoading: (state) => state.filterForm.vehiclesFilterLoading,
      advertiserTypes: (state) => state.filterForm.advertiserTypes,
    }),
  },
  methods: {
    ...mapMutations("sections", ["setSections"]),
    ...mapActions("filterForm", ["loadFromCache"]),
    ...mapMutations("filterForm", ["setLoading"]),
    ...mapMutations("filterForm", ["setKmMin", "setKmMax"]),
    ...mapMutations("drawer", [
      "hideReorganizationDrawer",
      "showReorganizationDrawer",
      "hideReorganizationDrawer",
      "showSeeAllDrawer",
    ]),
    ...mapMutations("filterForm", ["setFipeValue", "setFipe"]),
    ...mapMutations("filterForm", ["setPriceMin", "setPriceMax"]),
    ...mapMutations("filterForm", ["setYearMin", "setYearMax"]),
    reorganizationDrawerHandler() {
      if (localStorage.getItem("sections")) {
        try {
          this.setSections(JSON.parse(localStorage.getItem("sections")))
        } catch (e) {
          localStorage.removeItem("sections");
        }
      } else {
        this.setSections(SECTIONS_DEFAULT)
      }
      this.hideReorganizationDrawer();
    },
    scrollToTop() {
      setTimeout(() => {
        const div = this.isMobile() ?
            document.querySelector("#filter-app-dialog") :
            document.querySelector("#filter-app")
        if (div) {
          div.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      }, 200);
    },
    scrollToElement(el) {
      setTimeout(() => {
        const div = this.isMobile() ?
            document.querySelector("#filter-app-dialog") :
            document.querySelector("#filter-app")
        const element = document.getElementById(el);
        if (div && element) {
          div.scrollTo({
            top: element.offsetTop,
            behavior: "smooth",
          });
        }
      }, 200);
    },
    limparFiltro($store) {
      $store.commit('filterForm/clear');
      $store.commit('drawer/clear');

      if(this.validParam){
        this.$store.commit("filterForm/setParam", { entity: this.$route.params.name });
      }

      this.$refs.fipeComponentRef[0].changeRange();
    },
    async loadAdvertiserTypeForCompany(companyUrl) {
      try {
        const advertiserType = await getAdvertiserTypeByCompanyUrl(companyUrl);

        if (advertiserType && advertiserType.id) {
          this.$store.commit('filterForm/updateParamsWithoutRefresh', {
            ...this.params,
            adType: [
              { id: advertiserType.id.toString(), name: advertiserType.title }
            ],
          });
        }
      } catch (error) {
        console.error('Erro ao buscar tipo de anunciante:', error);
      }
    },

    seeAllBrandsClickHandler() {
      this.scrollToTop();
      return this.optionalsData.brands;
    },
    seeAllOptionalsClickHandler() {
      this.scrollToTop();
      return this.optionalsData.optionals;
    },
  },
};
</script>

<style>
#filter-sidebar {
  padding: 0 20px;
  background-color: #fafafa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.sidebar-item {
  margin: 0.5rem auto;
  padding-bottom: 12px;
}

.spacer-fill {
  flex: 1;
  min-height: 50px;
}

.loading {
  font-family: "Lexend Deca";
  text-align: center;
  color: #c6c6c6;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 77px;
  background: #efefef;
  box-shadow: 0px -2px 22px rgba(0, 0, 0, 0.25);
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 1000000;
}

.container {
  padding: 40px;
}

.footer #button {
  background: #ff7a00;
  border-radius: 4px;
  font-family: "Lexend Deca";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: normal;
  width: 248px;
  height: 49px;
  opacity: 1;

  color: #ffffff;
}

.clear-button {
  display: flex;
  height: 27px;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
}

.clear-button:hover {
  opacity: 0.8;
}

.clear-button span {
  color: #000;
  font-size: 14px;
  font-family: "Lexend Deca";
  font-weight: 700;
  margin-left: 4px;
}

#autoavaliar-logo {
  margin-top: 28px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.img{
  width: 80%;
  margin-bottom: 50px;
}
</style>
